if (!window.Eurus.loadedScript.has('seadent-product-page-checkout.js')) {
  window.Eurus.loadedScript.add('seadent-product-page-checkout.js');
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
       Alpine.data('xProductCheckoutValidator', (product) => ({
        show: false,
        disable: true,
        price: product.price,
        isLoading: true,

        async init() {
          document.addEventListener('pdp-qty-changed', async (e) => {
            const newQty = e.detail.qty;
            this.updateStickyQuantity(newQty);
            await this.updateQuantity(newQty);
          });
          const optionLabelEls = document.querySelectorAll('label.option-label');
          optionLabelEls.forEach((optionLabelEl) => {
            optionLabelEl.addEventListener('click', async () => {
              this.isLoading = true;
              this.disable = true;
              setTimeout(async () => {
                const qty = document.querySelector(".quantity-selector input")?.value || 1;
                const price = document.querySelector(".main-product-price .currentPrice")?.dataset?.price;
                this.price = price;
                const validateBeforeProductCheckout = await Alpine.store('xMinMaxCartRule')
                  ?.validateBeforeProductCheckout(product.id, qty , price / 100, product.title);
                
                this.disable = !validateBeforeProductCheckout;
                this.isLoading = false;
              }, 1000);
            });
          })
        },
        async updateQuantity(qty) {
          this.isLoading = true;
          this.disable = true;
          const validateBeforeProductCheckout = await Alpine.store('xMinMaxCartRule')
            ?.validateBeforeProductCheckout(product.id, qty , this.price / 100, product.title);
          
          this.disable = !validateBeforeProductCheckout;
          this.isLoading = false;
        },
        async handleProductCheckout() {
          this.isLoading = true;
          const qty = document.querySelector(".quantity-selector input")?.value || 1;
          await Alpine.store('xMinMaxCartRule').validateBeforeProductCheckout(product.id, qty, this.price / 100, product.title , true);
          this.isLoading = false;
        },
        updateStickyQuantity(qty) {
          document.querySelector(".quantity-sticky-selector").value = qty;
        }
      }));
    });
  });
}
